import "./NewsieTakeawayPoint.css";

import React, { useState } from "react";

const NewsieTakeawayPoint = (props) => {
  const {
    onSelectTakeaway,
    selectedTakeawayIndex,
    selectedTakeawayText,
    onChangeSelectedTakeawayText,
    onSaveNewsieTakeawayText,
    onSelectTakewayPointText,
    takeawayPoint,
    takeawayWords,
    takeawayIndex,
    onSelectEditorWord,
    editorSelectedWordCoordinates,
    selectedEditorWord,
    onChangeSelectedWord,
    onSaveSelectedWord,
    onClickDeleteTakeawayPoint,
  } = props;

  return (
    <div className="newsie-takeaway-point-editor-container">
      <div className="newsie-takeaway-point-delete-button-container">
        <div
          className="newsie-takeway-point-delete-button"
          onClick={() => onClickDeleteTakeawayPoint(takeawayIndex)}
        >
          <b>X</b>
        </div>
      </div>

      {selectedTakeawayIndex === takeawayIndex ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <textarea
            type="text"
            style={{ width: 300, height: 50, resize: "none" }}
            value={selectedTakeawayText}
            onChange={(e) => onChangeSelectedTakeawayText(e.target.value)}
          />
          <div
            className="quiz-edit-field-save"
            onClick={(e) => {
              e.stopPropagation();
              onSaveNewsieTakeawayText(selectedTakeawayText);
            }}
          >
            ✔
          </div>
        </div>
      ) : (
        <div onClick={() => onSelectTakeaway(takeawayIndex, takeawayPoint)}>{takeawayPoint || 'Add a Takeaway'}</div>
      )}

      <div className="newsie-takeaway-words-container">
        {takeawayWords.map((word, i) => {
          if (
            editorSelectedWordCoordinates?.columnIndex === i &&
            editorSelectedWordCoordinates?.wordIndex === takeawayIndex
          ) {
            return (
              <div
                className="quiz-edit-field-container"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="text"
                  value={selectedEditorWord}
                  onChange={(e) => onChangeSelectedWord(e.target.value)}
                />
                <div className="quiz-edit-field-buttons-container">
                  <div
                    className="quiz-edit-field-save"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSaveSelectedWord();
                      // handleSaveEditOption(index);
                      // setEditorSelectedOption(null);
                    }}
                  >
                    ✔
                  </div>
                </div>
              </div>
            );
          }
          return (
            <div
              className="newsie-takeaway-word"
              onClick={() => onSelectEditorWord(i, takeawayIndex, word)}
            >
              {word}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NewsieTakeawayPoint;
